import {Component, EventEmitter, Input, Output} from '@angular/core';

import {isValidFormat} from '../../utils/files';

@Component({
  selector: 'gp-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss']
})
export class UploadFileComponent {

  @Input()
  public contentType: string;

  @Input()
  public minimalDisplay: boolean = true;

  @Input()
  public maxFileSize: number;

  @Input()
  public isDisabled: boolean = false;

  @Output()
  public uploadedFile: EventEmitter<File> = new EventEmitter<File>();

  @Output()
  public isFileDeleted: EventEmitter<boolean> = new EventEmitter<boolean>();

  public isOver: boolean = false;
  public isMaxFileSize: boolean = false;
  public savedMsg: boolean = false;
  public loading: boolean = false;
  public file: File;
  public isFileFormatValid: boolean = true;

  public onDragOver(): void {
    this.isOver = true;
  }

  public onDragLeave(): void {
    this.isOver = false;
  }

  public onDrop(): void {
    this.isOver = false;
  }

  public deleteFile() {
    this.file = null;
    this.isMaxFileSize = false;
    this.isFileFormatValid = true;
    this.isFileDeleted.emit(true);
  }

  public uploadFile(event) {
    if (event.target.files.length > 0) {
      this.file = event.target.files[0];
      event.target.value = null;
      if (this.file.size >= this.maxFileSize) {
        this.isMaxFileSize = true;
        return;
      } else {
        this.isMaxFileSize = false;
      }
      this.isFileFormatValid = isValidFormat(this.contentType, this.file.name);

      if (this.isFileFormatValid) {
        this.uploadedFile.emit(this.file);
      }
    }
  }

}
